import React,{useEffect,useState,useReducer,useContext} from 'react';
import { Link,useNavigate} from 'react-router-dom';
import {conitem} from '../context/Contextitem'
import { categoriesurl} from '../component/Fetcher';



const initaistate ={
 
    loading : true,
    data : [],
    error : '',

}


const reducer = (state,action)=>{
  
  switch(action.type){
    case 'sucess' :
      return{...state,
        loading: false ,
        data: action.payload,
        error: ''
      }
 case 'error' :
    return{...state,
      loading: false ,
      data: [],
      error: action.errormessage
    }
  }
}

const Bigscreenheader = () => {

  const navigate = useNavigate();
   const[ count , dispatch] = useReducer(reducer,initaistate)
     const { basketiconvalue} = useContext(conitem)

   useEffect(()=>{
      
       categoriesurl({dispatch})
        
     },[])
     
   const rerender = ()=>{
     return count.data.map(data=>(
     
     <p key={data.id}><Link style={{color:'black',textDecoration:'none'}} to={`/categories/${data.id}`}>{data.title}</Link></p>
      
     ))
   }
  return (
    <div id='Bigscreenheader-wrapper'>
<div id='logo-container'>
<img onClick={()=>navigate('/')} src={'/asset/logo1project.jpg'} alt=""  />
</div>

<div id='categories-drop-down'> 
  {rerender()}
<p>Groceries</p>
<p>Premiun Fruits</p>
{/* <p>Home & Kitchen</p>
<p>Fashion</p>
<p>Electronic</p>
<p>Beauty</p> */}

</div>

<div id='task-wrapper'>

<div onClick={()=>navigate('/Login')} id='sign-in-wrapper'>
        <img  src="/asset/icon-user.svg" alt="" srcset="" />
        <p>Login</p>
       </div>
      <div id='cart'>
  <img onClick={()=>navigate('/basket')} src="/asset/icon-cart.svg" alt=""  />
  <p>{basketiconvalue}</p>
</div>
  
</div>
    </div>
  )
}

export default Bigscreenheader